import Logo from './Logo';
import LogoSecond from './LogoSecond';
import { useTranslation } from 'react-i18next';

export default function Footer(){
    const { t } = useTranslation();

  return (
    <footer class={"shadow-lg bg-orange-50"}>
        <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
            <div class="sm:flex sm:items-center sm:justify-between">
                <div>
                    <a href="https://sefos.cz/" class="flex items-center sm:mb-0 space-x-3 rtl:space-x-reverse">
                        <Logo  style="h-6"/>
                        <span class="self-center text-lg font-semibold whitespace-nowrap pt-2 text-gray-800">{t("main_company")}</span>
                    </a>
                    <span class="text-gray-800 font-semibold text-sm">IČO:&nbsp;071&nbsp;94&nbsp;790 DIČ:&nbsp;CZ07194790 EORI:&nbsp;CZ07194790</span>
                </div>
                {/*<ul class="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
                    <li>
                        <a href="#" class="hover:underline me-4 md:me-6">About</a>
                    </li>
                    <li>
                        <a href="#" class="hover:underline me-4 md:me-6">Privacy Policy</a>
                    </li>
                    <li>
                        <a href="#" class="hover:underline me-4 md:me-6">Licensing</a>
                    </li>
                    <li>
                        <a href="#" class="hover:underline">Contact</a>
                    </li>
                </ul>*/}
                <div class="text-right">
                    <a href="https://trameco.cz/" class="flex items-center sm:mb-0 space-x-3 rtl:space-x-reverse flex justify-end">
                        <span class="self-center text-lg font-semibold whitespace-nowrap pt-2 text-gray-800">{t("also_known")}</span>
                        <LogoSecond style="h-6"/>
                    </a>
                    <span class="text-gray-800 font-semibold text-sm">IČO:&nbsp;078&nbsp;81&nbsp;380 DIČ/VAT:&nbsp;CZ07881380 EORI:&nbsp;CZ07881380</span>
                </div>
                

            </div> 
        </div>
    </footer>
  );

};